"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentMethodMapByLowerCaseValue = exports.getFirstErrorMessage = exports.isDataForPaymentImportValid = exports.isPaymentDataValid = exports.isDataForUsersImportValid = exports.isUserDataValid = exports.getAllListsFromRow = exports.isValidCountryCode = exports.isDataValid = exports.getImportExpirationDateKey = exports.getImportDateKey = exports.importRegionKey = exports.doesTitleMentionTicket = exports.TICKET_TITLE_KEYWORDS = exports.TICKET_TITLE_KEYWORDS_BY_LOCALE = exports.ImportPaymentType = exports.ImportType = exports.INVALID_LIST_NAME_CHARS = exports.MAX_LIST_NAME_LENGTH = exports.parseAmountWithCommaOrThousands = exports.getAmountFromStringInput = void 0;
const validator_1 = require("validator");
const import_1 = require("../constants/import");
const validation_1 = require("../constants/validation");
const payment_1 = require("../enums/payment");
const internationalization_1 = require("../internationalization");
const country_1 = require("../internationalization/enums/country");
const locales_1 = require("../internationalization/enums/locales");
const locales_2 = require("../internationalization/features/locales");
const crm_custom_property_import_1 = require("./crm-custom-property-import");
const import_amount_1 = require("./import.amount");
const utils_1 = require("./utils");
var import_amount_2 = require("./import.amount");
Object.defineProperty(exports, "getAmountFromStringInput", { enumerable: true, get: function () { return import_amount_2.getAmountFromStringInput; } });
Object.defineProperty(exports, "parseAmountWithCommaOrThousands", { enumerable: true, get: function () { return import_amount_2.parseAmountWithCommaOrThousands; } });
exports.MAX_LIST_NAME_LENGTH = 255;
// eslint-disable-next-line no-control-regex
exports.INVALID_LIST_NAME_CHARS = /[<>:"/\\|?*\x00-\x1F]/;
var ImportType;
(function (ImportType) {
    ImportType["Contact"] = "Contact";
    ImportType["Payment"] = "Payment";
    ImportType["Template"] = "Template";
    ImportType["Email"] = "Email";
})(ImportType || (exports.ImportType = ImportType = {}));
var ImportPaymentType;
(function (ImportPaymentType) {
    ImportPaymentType["Ticket"] = "ticket";
    ImportPaymentType["Donation"] = "donation";
    ImportPaymentType["Membership"] = "membership";
    ImportPaymentType["Abonnement"] = "abonnement";
})(ImportPaymentType || (exports.ImportPaymentType = ImportPaymentType = {}));
exports.TICKET_TITLE_KEYWORDS_BY_LOCALE = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: ["ticket", "tickets", "ticketing", "admission", "admissions", "seat", "seats", "entry"],
    [locales_1.Locales.FR]: ["billet", "billets", "billetterie", "entrée", "entrées"],
    [locales_1.Locales.ES]: ["entrada", "entradas", "boleto", "boletos", "billete", "billetes", "asiento", "asientos"],
    [locales_1.Locales.DE]: ["ticket", "tickets", "eintritt", "eintrittskarte", "eintrittskarten", "sitzplatz", "sitzplätze"],
});
exports.TICKET_TITLE_KEYWORDS = Array.from(new Set(Object.values(exports.TICKET_TITLE_KEYWORDS_BY_LOCALE).flat()));
const TICKET_TITLE_KEYWORD_REGEX = new RegExp(`\\b(?:${exports.TICKET_TITLE_KEYWORDS.join("|")})\\b`, "i");
const doesTitleMentionTicket = (title) => {
    if (!title) {
        return false;
    }
    return TICKET_TITLE_KEYWORD_REGEX.test(title);
};
exports.doesTitleMentionTicket = doesTitleMentionTicket;
exports.importRegionKey = "state/province";
const getImportDateKey = (country) => {
    return `date (${(0, internationalization_1.getDateFormatByCountry)(country)})`;
};
exports.getImportDateKey = getImportDateKey;
const getImportExpirationDateKey = (country) => {
    return `expiration date (${(0, internationalization_1.getDateFormatByCountry)(country)})`;
};
exports.getImportExpirationDateKey = getImportExpirationDateKey;
const isDataValid = ({ jsonData, type, country, customPropertyMappings, }) => {
    if (jsonData.length === 0) {
        return { isValid: false, fileError: { code: "no_data", message: "Import file is empty" }, invalidRowIndexes: [] };
    }
    if (jsonData.length > import_1.MAX_COUNT_IN_IMPORT) {
        return {
            isValid: false,
            fileError: { code: "too_many_rows", message: "Import has too many rows" },
            invalidRowIndexes: [],
        };
    }
    if (type === ImportType.Contact) {
        return (0, exports.isDataForUsersImportValid)(jsonData, { customPropertyMappings, country });
    }
    if (type === ImportType.Payment) {
        return (0, exports.isDataForPaymentImportValid)({ csvData: jsonData, country, customPropertyMappings });
    }
    return {
        isValid: false,
        fileError: { code: "missing_import_type", message: "Import type is missing" },
        invalidRowIndexes: [],
    };
};
exports.isDataValid = isDataValid;
const isValidCountryCode = (country) => {
    return Object.values(country_1.CountryCode).includes(country);
};
exports.isValidCountryCode = isValidCountryCode;
const serializeImportPaymentDataError = (invalidPayments) => invalidPayments.map((invalidRow) => ({
    row: invalidRow.index + 1,
    invalidColumns: invalidRow.invalidData,
    emptyColumns: invalidRow.emptyData,
    data: invalidRow.data,
}));
const getAllListsFromRow = (current) => {
    return (current.list
        ?.replace(";", ",")
        ?.split(",")
        .map((list) => list.trim())
        .filter(utils_1.Utils.notEmpty) || []);
};
exports.getAllListsFromRow = getAllListsFromRow;
const isUserDataValid = (current, customPropertyMappings = [], country = null) => {
    const isFirstNameExists = Boolean(current.firstName);
    const isLastNameExists = Boolean(current.lastName);
    const isCompanyNameExists = Boolean(current.companyName);
    const isHouseholdNameExists = Boolean(current.householdName);
    const lists = (0, exports.getAllListsFromRow)(current);
    const isListsExists = Boolean(lists.length > 0);
    const isLocaleValid = current.language
        ? Object.values(locales_1.Locales).includes(current.language.toUpperCase())
        : true;
    const isFirstNameValid = isFirstNameExists ? validation_1.nameValidationRegex.test(current.firstName) : true;
    const isLastNameValid = isLastNameExists ? validation_1.nameValidationRegex.test(current.lastName) : true;
    const isCompanyNameValid = isCompanyNameExists
        ? validation_1.companyNameValidationRegex.test(current.companyName)
        : true;
    const isHouseholdNameValid = isHouseholdNameExists
        ? validation_1.companyNameValidationRegex.test(current.householdName)
        : true;
    const isEmailValid = current.email ? (0, validator_1.isEmail)(current.email) : true;
    const isSecondaryEmailValid = current.secondaryEmail ? (0, validator_1.isEmail)(current.secondaryEmail) : true;
    const isCountryValid = !current.country || (0, exports.isValidCountryCode)(current.country.toUpperCase());
    const atLeastOneIdentifierExists = current.email || isFirstNameExists || isLastNameExists;
    const isValidLists = isListsExists
        ? lists.every((list) => list.length > 0 && list.length <= exports.MAX_LIST_NAME_LENGTH && !exports.INVALID_LIST_NAME_CHARS.test(list))
        : true;
    const invalidCustomPropertyMappings = customPropertyMappings.filter(({ fieldKey, propertyType }) => !(0, crm_custom_property_import_1.isCrmCustomPropertyImportValueValid)({ raw: current[fieldKey] ?? "", propertyType, country }));
    const invalidData = [
        isLocaleValid ? undefined : "language",
        isEmailValid ? undefined : "email",
        isSecondaryEmailValid ? undefined : "secondaryEmail",
        isCountryValid ? undefined : "country",
        isFirstNameValid ? undefined : "firstName",
        isLastNameValid ? undefined : "lastName",
        isCompanyNameValid ? undefined : "companyName",
        isHouseholdNameValid ? undefined : "householdName",
        atLeastOneIdentifierExists ? undefined : "atLeastOneIdentifierExists",
        isValidLists ? undefined : "list",
        ...invalidCustomPropertyMappings.map(({ fieldKey }) => fieldKey),
    ].filter(utils_1.Utils.notEmpty);
    const emptyData = [
        isFirstNameExists ? undefined : "firstName",
        isLastNameExists ? undefined : "lastName",
    ].filter(utils_1.Utils.notEmpty);
    const data = [
        !isLocaleValid ? current.language : undefined,
        !isEmailValid ? current.email : undefined,
        !isSecondaryEmailValid ? current.secondaryEmail : undefined,
        !isCountryValid ? current.country : undefined,
        !isFirstNameValid ? current.firstName : undefined,
        !isLastNameValid ? current.lastName : undefined,
        !isCompanyNameValid ? current.companyName : undefined,
        !isHouseholdNameValid ? current.householdName : undefined,
        !isValidLists ? current.list : undefined,
        ...invalidCustomPropertyMappings.map(({ fieldKey }) => current[fieldKey]),
    ].filter(utils_1.Utils.notEmpty);
    return { invalidData, emptyData, data };
};
exports.isUserDataValid = isUserDataValid;
const isDataForUsersImportValid = (csvData, options = {}) => {
    const invalidRowIndexes = [];
    const invalidUsers = csvData.reduce((prev, current, index) => {
        const { invalidData, emptyData, data } = (0, exports.isUserDataValid)(current, options.customPropertyMappings, options.country ?? null);
        if (invalidData.length === 0) {
            return prev;
        }
        invalidRowIndexes.push(index);
        const { firstName, lastName } = current;
        return [
            ...prev,
            {
                index: index + 1,
                firstName,
                lastName,
                invalidData,
                emptyData,
                data,
            },
        ];
    }, []);
    if (invalidUsers && invalidUsers.length > 0) {
        const rowErrors = serializeImportPaymentDataError(invalidUsers);
        return { isValid: false, rowErrors, invalidRowIndexes };
    }
    else {
        return { isValid: true, invalidRowIndexes: [] };
    }
};
exports.isDataForUsersImportValid = isDataForUsersImportValid;
const isPaymentDataValid = ({ current, country, customPropertyMappings, }) => {
    const { invalidData: userInvalidData, emptyData: userEmptyData, data: userData, } = (0, exports.isUserDataValid)(current, customPropertyMappings, country);
    const isAmountExists = Boolean(current.amount);
    const isAmountValid = !current.amount || !isNaN((0, import_amount_1.getAmountFromStringInput)(current.amount));
    const isEligibleAmountValid = !current.eligibleAmount || !isNaN((0, import_amount_1.getAmountFromStringInput)(current.eligibleAmount));
    const isReceiptUrlValid = !current.receiptNumber?.trim() || Boolean(current.receiptUrl?.trim());
    const isPaymentMethodValid = current.paymentMethod
        ? Boolean(exports.paymentMethodMapByLowerCaseValue[current.paymentMethod.toLowerCase()])
        : true;
    const isDateValid = !current[(0, exports.getImportDateKey)(country)] ||
        (current[(0, exports.getImportDateKey)(country)] &&
            !isNaN((0, internationalization_1.parseDateByCountry)(current[(0, exports.getImportDateKey)(country)], country).getTime()));
    const isExpirationDateValid = !current[(0, exports.getImportExpirationDateKey)(country)] ||
        (current[(0, exports.getImportExpirationDateKey)(country)] &&
            !isNaN((0, internationalization_1.parseDateByCountry)(current[(0, exports.getImportExpirationDateKey)(country)], country).getTime()));
    const invalidData = [
        ...userInvalidData,
        isPaymentMethodValid ? undefined : "paymentMethod",
        isDateValid ? undefined : (0, exports.getImportDateKey)(country),
        isExpirationDateValid ? undefined : (0, exports.getImportExpirationDateKey)(country),
        isAmountExists && isAmountValid ? undefined : "amount",
        isEligibleAmountValid ? undefined : "eligibleAmount",
        isReceiptUrlValid ? undefined : "receiptUrl",
    ].filter(utils_1.Utils.notEmpty);
    const emptyData = [...userEmptyData].filter(utils_1.Utils.notEmpty);
    const data = [...userData, !isAmountExists ? current.amount : undefined].filter(utils_1.Utils.notEmpty);
    return { invalidData, emptyData, data };
};
exports.isPaymentDataValid = isPaymentDataValid;
const isDataForPaymentImportValid = ({ csvData, country, customPropertyMappings, }) => {
    const invalidRowIndexes = [];
    const invalidPayments = csvData.reduce((prev, current, index) => {
        const { invalidData, emptyData, data } = (0, exports.isPaymentDataValid)({ current, country, customPropertyMappings });
        if (invalidData.length === 0) {
            return prev;
        }
        invalidRowIndexes.push(index);
        const { firstName, lastName } = current;
        return [
            ...prev,
            {
                index: index + 1,
                firstName,
                lastName,
                invalidData,
                emptyData,
                data,
            },
        ];
    }, []);
    if (invalidPayments && invalidPayments.length > 0) {
        const rowErrors = serializeImportPaymentDataError(invalidPayments);
        return { isValid: false, rowErrors, invalidRowIndexes };
    }
    else {
        return { isValid: true, invalidRowIndexes: [] };
    }
};
exports.isDataForPaymentImportValid = isDataForPaymentImportValid;
const getFirstErrorMessage = (rowErrors) => {
    const firstError = rowErrors[0];
    const invalidFields = firstError.invalidColumns.join(", ");
    const data = firstError.data.join(", ");
    return `Row ${firstError.row - 1} has invalid data in field(s): ${invalidFields} with data: ${data}`;
};
exports.getFirstErrorMessage = getFirstErrorMessage;
exports.paymentMethodMapByLowerCaseValue = Object.values(payment_1.PaymentMethod).reduce((prev, curr) => {
    return { ...prev, [curr.toLowerCase()]: curr };
}, {});
